import { ClipboardCheck, Wrench, Sparkles } from "lucide-react";
import FadeIn from "@/components/FadeIn";

const STEPS = [
  {
    icon: ClipboardCheck,
    title: "Étude gratuite à domicile",
    text: "Un technicien Ener Solutions vient chez vous : puissance nécessaire, emplacement des unités, passage des liaisons. Devis clair, sans engagement.",
    when: "Sous 48 h",
  },
  {
    icon: Wrench,
    title: "Installation sous 15 jours",
    text: "Pose par nos propres techniciens, jamais de sous-traitant. Un monosplit se pose généralement en une journée, dans un chantier propre.",
    when: "1 journée",
  },
  {
    icon: Sparkles,
    title: "Mise en service & réglages",
    text: "Tests, paramétrage de l'application Daikin Onecta avec vous, conseils d'entretien. Notre SAV local répond sous 48 h.",
    when: "Le jour même",
  },
];

export default function ClimProcess() {
  return (
    <section
      id="methode"
      data-testid="clim-section-methode"
      className="bg-glacier py-24 sm:py-32"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <div>
          <FadeIn>
            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-ice sm:text-xs">
              Comment ça se passe
            </p>
            <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-5xl">
              Trois rendez-vous, et il fait bon chez vous.
            </h2>
          </FadeIn>

          <ol className="mt-12 space-y-8">
            {STEPS.map((s, i) => (
              <FadeIn key={s.title} delay={i * 0.1}>
                <li data-testid={`clim-process-step-${i}`} className="flex gap-5">
                  <div className="flex flex-col items-center">
                    <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white text-ice shadow-card">
                      <s.icon className="h-5 w-5" />
                    </span>
                    {i < STEPS.length - 1 && (
                      <span className="mt-3 h-full w-px flex-1 bg-gradient-to-b from-ice/40 to-transparent" />
                    )}
                  </div>
                  <div className="pb-2">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="font-mono text-[11px] font-semibold text-slate-400">
                        0{i + 1}
                      </span>
                      <h3 className="font-display text-lg font-bold text-ink sm:text-xl">
                        {s.title}
                      </h3>
                      <span className="rounded-full bg-ice-light px-2.5 py-0.5 text-[11px] font-semibold text-ice">
                        {s.when}
                      </span>
                    </div>
                    <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-600">
                      {s.text}
                    </p>
                  </div>
                </li>
              </FadeIn>
            ))}
          </ol>
        </div>

        <FadeIn delay={0.1} className="relative">
          <div className="overflow-hidden rounded-[2rem] shadow-card">
            <img
              src="/clim-pose.webp"
              alt="Technicien Ener Solutions installant une climatisation Daikin"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 left-4 rounded-2xl border border-glacier-border bg-white px-5 py-4 shadow-card sm:left-8">
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-ice">
              Nos propres techniciens
            </p>
            <p className="mt-1 font-display text-lg font-extrabold text-ink">
              0 sous-traitant, 1 interlocuteur
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
